import { Slider } from '@/components/ui/Slider';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'slider',
  renderInput: ({ field, value, onChange }) => {
    const rules = (field as { validationRules?: Record<string, unknown> }).validationRules ?? {};
    const min = Number(rules['min'] ?? 0);
    const max = Number(rules['max'] ?? 100);
    const step = Number(rules['step'] ?? 1);
    return (
      <Slider
        value={(value as number) ?? min}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
      />
    );
  },
  renderCell: (_field, value) => {
    if (value == null) return '—';
    return String(value);
  },
  validate: (value, field) => {
    if (value == null) return field.isRequired ? 'Pole wymagane' : null;
    if (isNaN(Number(value))) return 'Musi być liczbą';
    return null;
  },
  defaultValue: 0,
});
